import { PastWinnersPage } from '@/pages/past-winners/component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/past-winners')({
	component: PastWinnersPage,
});
